<script setup lang="ts">
/**
 * The 2.5-minute product walkthrough: how a CV is made, the templates, the web
 * card and the rest of the features. Czech visitors get the Czech cut, everyone
 * else the English one (the subtitles are burned in).
 *
 * The videos are rendered from doc/video; `preload="none"` keeps the ~10 MB file
 * off the first load, only the poster is fetched until someone presses play.
 */
const { t, locale } = useI18n()

const lang = computed(() => (locale.value === 'cs' ? 'cs' : 'en'))
const src = computed(() => `/video/walkthrough-${lang.value}.mp4`)
const poster = computed(() => `/video/walkthrough-${lang.value}.jpg`)
</script>

<template>
  <section id="video" class="sofax overflow-hidden bg-white dark:bg-gray-950">
    <div class="section-space">
      <div class="shell">
        <SofaxSectionHeading
          :eyebrow="t('homepage.videoWalkthrough.eyebrow')"
          :title="t('homepage.videoWalkthrough.title')"
          :text="t('homepage.videoWalkthrough.text')"
        />

        <div class="mx-auto max-w-5xl overflow-hidden rounded-[0.625rem] border border-line bg-gray-900 shadow-lift dark:border-gray-700">
          <!-- :key swaps the element when the language changes, so the new source loads -->
          <video
            :key="src"
            class="aspect-video w-full"
            :src="src"
            :poster="poster"
            :aria-label="t('homepage.videoWalkthrough.title')"
            controls
            playsinline
            preload="none"
            width="1280"
            height="720"
          />
        </div>
      </div>
    </div>
  </section>
</template>
